import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import './assets/css/App.css'
import './assets/js/imgData';
import data from './data.json';

//COMPONENTS
import Landing from './components/Landing';
import Proyect from './components/Proyect';
import Footer from './components/Footer';

const App = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" exact element={<Landing data={data} />} />
        <Route path="/proyect/:proyect" element={<Proyect data={data} listNav="true" />} />
      </Routes>
      <Footer></Footer>
    </BrowserRouter>
  );
}

export default App;
